import {
  FieldValues,
  Path,
  UseFormRegister,
  FieldErrors,
  RegisterOptions,
  Controller,
} from 'react-hook-form'
import {getFieldError} from './getFieldError'

interface RadioOption {
  label: string | React.ReactNode
  subLabel?: string | React.ReactNode
  value: string | number | boolean
}

export const RadioButtonInput = <T extends FieldValues>({
  name,
  label,
  errors,
  required = false,
  className = '',
  itemClassName = '',
  inputClassName = '',
  labelClassName = '',
  options,
  control,
  onChange,
}: any) => {
  const error = getFieldError(errors, name)
  const formatLabel = (label: RadioOption['label']) => {
    if (typeof label !== 'string') {
      return label
    }

    const match = label.match(/^(.*?)(\s*\(.*\))$/)
    if (!match) return label

    return (
      <>
        {match[1]}
        <span className='text-muted'>{match[2]}</span>
      </>
    )
  }
  const renderOptionLabel = (option: RadioOption) => (
    <>
      <span className={option.subLabel ? 'fw-semibold' : ''}>{formatLabel(option.label)}</span>
      {option.subLabel && (
        <span className='text-muted small d-block mt-1 fs-5'>{option.subLabel}</span>
      )}
    </>
  )

  return (
    <div className={`mb-5 ${className}`}>
      {label && (
        <label className='form-label fw-semibold'>
          {label} {required && <span className='text-danger'>*</span>}
        </label>
      )}

      <Controller
        name={name}
        control={control}
        rules={{
          validate: required
            ? (value) =>
                value !== undefined && value !== null && value !== ''
                  ? true
                  : 'This field is required'
            : undefined,
        }}
        render={({field}) => (
          <div>
            {options.map((option: any, idx: any) => {
              const isChecked = field.value === option.value

              return (
                <div
                  className={`form-check d-flex align-items-start mb-2 ${itemClassName}`}
                  key={idx}
                >
                  <input
                    type='radio'
                    id={`${String(name)}-${idx}`}
                    className={`form-check-input mt-2 ${inputClassName}`}
                    value={String(option.value)}
                    checked={isChecked}
                    onChange={() => {
                      field.onChange(option.value)
                      onChange?.(option.value)
                    }}
                    onBlur={field.onBlur}
                  />

                  <label
                    htmlFor={`${String(name)}-${idx}`}
                    className={`form-check-label mt-2 mx-5 fs-semibold ${labelClassName}`}
                  >
                    {renderOptionLabel(option)}
                  </label>
                </div>
              )
            })}
          </div>
        )}
      />

      {error && <div className='text-danger mt-1'>{String(error.message)}</div>}
    </div>
  )
}
